import {Component, forwardRef} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIRadioPillComponent),
            multi: true
        }
    ],
    selector: "fui-radio-pill",
    templateUrl: "./radio-pill.component.html",
    standalone: false
})
export class FUIRadioPillComponent extends FUIAbstractPill {
}
